module.exports = __webpack_public_path__ + "img/limit2en.ece8f084.png";